import React, { useState } from 'react';
export function SpecialsSection() {
  const [activeTab, setActiveTab] = useState('All Deals');
  const tabs = ['All Deals', 'Best Savings', 'Members Only'];
  return <section className="section-padding bg-white" data-id="element-208">
      <div className="container-wide" data-id="element-209">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-8 gap-6" data-id="element-210">
          <div data-id="element-211">
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-gray-900 mb-2" data-id="element-212">
              This Week's Specials
            </h2>
            <p className="text-lg text-red-600 font-medium flex items-center gap-2" data-id="element-213">
              <span className="w-2 h-2 rounded-full bg-red-600 animate-pulse" data-id="element-214"></span>
              Limited time offers — don't miss out
            </p>
          </div>

          {/* Filter Tabs */}
          <div className="flex flex-wrap gap-2" data-id="element-215">
            {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-2 rounded-full text-sm font-bold transition-all active:scale-95 ${activeTab === tab ? 'bg-brand-blue text-white shadow-md' : 'bg-white text-gray-600 border border-gray-200 hover:border-brand-blue hover:text-brand-blue'}`} data-id="element-216">
                {tab}
              </button>)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-217">
          {/* Card 1 */}
          <div className="rounded-2xl overflow-hidden relative group cursor-pointer shadow-card hover:shadow-card-hover transition-all duration-500 h-[280px] sm:h-[320px] active:scale-[0.98]" data-id="element-218">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&q=80')] bg-cover bg-center transition-transform duration-700 group-hover:scale-105" data-id="element-219"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-brand-blue-900/95 via-brand-blue-900/80 to-transparent" data-id="element-220"></div>

            <div className="relative z-10 p-6 sm:p-8 h-full flex flex-col w-full sm:w-3/4" data-id="element-221">
              <span className="badge-blue self-start mb-4 bg-white text-brand-blue shadow-sm" data-id="element-222">
                SAVE UP TO $20
              </span>
              <h3 className="font-heading font-bold text-xl sm:text-2xl text-white mb-2 leading-tight" data-id="element-223">
                Premium Dog Food 15-20kg
              </h3>
              <div className="mt-auto" data-id="element-224">
                <div className="text-brand-blue-200 text-sm font-medium mb-1" data-id="element-225">
                  Was from $109
                </div>
                <div className="font-heading font-extrabold text-3xl sm:text-4xl text-white mb-4" data-id="element-226">
                  <span className="text-xl mr-1" data-id="element-227">FROM</span>$89
                </div>
                <button className="text-white font-bold flex items-center gap-2 hover:text-brand-blue-200 transition-colors" data-id="element-228">
                  Shop Offer <span data-id="element-229">→</span>
                </button>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="rounded-2xl overflow-hidden relative group cursor-pointer shadow-card hover:shadow-card-hover transition-all duration-500 h-[280px] sm:h-[320px] active:scale-[0.98]" data-id="element-230">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&q=80')] bg-cover bg-center transition-transform duration-700 group-hover:scale-105" data-id="element-231"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-brand-green-900/95 via-brand-green-900/80 to-transparent" data-id="element-232"></div>

            <div className="relative z-10 p-6 sm:p-8 h-full flex flex-col w-full sm:w-3/4" data-id="element-233">
              <span className="badge-green self-start mb-4 bg-white text-brand-green shadow-sm" data-id="element-234">
                HALF PRICE
              </span>
              <h3 className="font-heading font-bold text-xl sm:text-2xl text-white mb-2 leading-tight" data-id="element-235">
                Spring Garden Fertilisers
              </h3>
              <div className="mt-auto" data-id="element-236">
                <div className="text-brand-green-200 text-sm font-medium mb-1" data-id="element-237">
                  Select varieties
                </div>
                <div className="font-heading font-extrabold text-3xl sm:text-4xl text-white mb-4" data-id="element-238">
                  <span className="text-xl mr-1" data-id="element-239">FROM</span>$12
                  <span className="text-2xl" data-id="element-240">.95</span>
                </div>
                <button className="text-white font-bold flex items-center gap-2 hover:text-brand-green-200 transition-colors" data-id="element-241">
                  Shop Offer <span data-id="element-242">→</span>
                </button>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="rounded-2xl overflow-hidden relative group cursor-pointer shadow-card hover:shadow-card-hover transition-all duration-500 h-[280px] sm:h-[320px] active:scale-[0.98]" data-id="element-243">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=600&q=80')] bg-cover bg-center transition-transform duration-700 group-hover:scale-105" data-id="element-244"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-900/95 via-cyan-900/80 to-transparent" data-id="element-245"></div>

            <div className="relative z-10 p-6 sm:p-8 h-full flex flex-col w-full sm:w-3/4" data-id="element-246">
              <span className="badge-warm self-start mb-4 bg-white text-cyan-700 shadow-sm" data-id="element-247">
                BUY 2 GET 1 FREE
              </span>
              <h3 className="font-heading font-bold text-xl sm:text-2xl text-white mb-2 leading-tight" data-id="element-248">
                Pool Chlorine and Chemicals
              </h3>
              <div className="mt-auto" data-id="element-249">
                <div className="text-cyan-200 text-sm font-medium mb-1" data-id="element-250">
                  Mix and match
                </div>
                <div className="font-heading font-extrabold text-3xl sm:text-4xl text-white mb-4" data-id="element-251">
                  <span className="text-xl mr-1" data-id="element-252">FROM</span>$29
                  <span className="text-2xl" data-id="element-253">.95</span>
                </div>
                <button className="text-white font-bold flex items-center gap-2 hover:text-cyan-200 transition-colors" data-id="element-254">
                  Shop Offer <span data-id="element-255">→</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}